module.exports = __webpack_public_path__ + "static/media/chapter-two-spooky.1745c494.png";